import { ConnectorStatusColor, DeviceType } from '@services/constants'
import env from '@shared/env'
import {
  markerIcon,
  MarkerImageType,
} from '@shared/innmaxMap/components/Marker'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

export default function Marker() {
  const { t } = useTranslation()

  const icon = markerIcon(
    {
      deviceType: DeviceType.LIGHT,
    } as any,
    MarkerImageType.SVG
  )

  return (
    <div className="m-40 flex flex-col h-full">
      <div className="flex gap-40 justify-center items-center">
        <div
          className="text-[#878787] text-xl relative z-10"
          css={css`
            &::after {
              content: '';
              position: absolute;
              width: 50px;
              height: 1px;
              border: solid 0.5px #878787;
              left: 105%;
              top: 50%;
            }
          `}>
          充電槍1狀態
        </div>
        <div
          css={css`
            width: 64px;
            height: 64px;
            border-radius: 0 50% 50% 50%;
            -webkit-transform: rotate(-135deg);
            -ms-transform: rotate(-135deg);
            transform: rotate(-135deg);
            box-shadow: 0 0 5px 0 rgb(0 0 0 / 75%);
            background-color: red;
            overflow: hidden;
            &::before {
              content: '';
              display: block;
              position: absolute;
              width: 50%;
              height: 120%;
              top: 0;
              left: -5%;
              z-index: 999;
              transform: rotate(135deg) scaleY(1.5);
              background-color: ${ConnectorStatusColor[1]};
            }
            &::after {
              content: '';
              display: block;
              position: absolute;
              left: 40%;
              top: -5px;
              width: 80%;
              height: 120%;
              transform: rotate(135deg) scaleY(1.5);
              background-color: ${ConnectorStatusColor[2]};
            }
          `}></div>
        <div
          className="text-[#878787] text-xl relative z-10"
          css={css`
            &::before {
              content: '';
              position: absolute;
              width: 50px;
              height: 1px;
              border: solid 0.5px #878787;
              right: 105%;
              top: 50%;
            }
          `}>
          充電槍2狀態
        </div>
      </div>

      <div
        style={{
          padding: '16px 40px 16px 20px',
          borderRadius: '5px',
          marginTop: '40px',
        }}>
        <div className="text-primary text-xl ">狀態說明</div>
        <div className="flex items-center justify-around mt-20 text-grey">
          <div>
            <div
              style={{
                background: ConnectorStatusColor[0],
                width: '40px',
                height: '40px',
                display: 'inline-block',
                margin: '0 8px',
                borderRadius: '20px',
              }}></div>
            <div className="text-lg">可使用</div>
          </div>
          <div>
            <div
              style={{
                background: ConnectorStatusColor[1],
                width: '40px',
                height: '40px',
                display: 'inline-block',
                margin: '0 8px',
                borderRadius: '20px',
              }}></div>
            <div className="text-lg">充電中</div>
          </div>
          <div>
            <div
              style={{
                background: ConnectorStatusColor[2],
                width: '40px',
                height: '40px',
                display: 'inline-block',
                margin: '0 8px',
                borderRadius: '20px',
              }}></div>
            <div className="text-lg">維修中</div>
          </div>
        </div>
      </div>
    </div>
  )
}

const StyledClustererWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: block;
  background: url(${env.imageUrlPrefix}/cluster/cluster-normal.svg) no-repeat
    center;
  background-size: 100%;
  margin: 0 auto 5px;
  position: relative;

  &::after {
    content: '10';
    color: #fff;
    left: 50%;
    top: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    font-size: 12px;
  }

  &.alarm {
    background-image: url(${env.imageUrlPrefix}/cluster/cluster-alarm.svg);
    &::after {
      content: '2';
      color: #fff;
    }
  }

  &.repair {
    background-image: url(${env.imageUrlPrefix}/cluster/cluster-repair.svg);
    &::after {
      content: '2';
      color: #fff;
    }
  }
`

const StyledMarkerAttached = styled.div`
  top: 18px;
  left: 142px;
  font-size: 15px;
  color: #878787;

  &::before {
    width: 43px;
    height: 1px;
    border: solid 0.5px #878787;
    content: ' ';
    position: absolute;
    left: -50px;
    top: 11px;
  }
`

const StyledMarkerStatus = styled.div`
  top: 87px;
  left: 142px;
  font-size: 15px;
  color: #878787;

  &::before {
    width: 70px;
    height: 1px;
    border: solid 0.5px #878787;
    content: ' ';
    position: absolute;
    left: -77px;
    top: 12px;
  }
`
